import React from "react";
import { Link } from "react-router-dom";
import { Paths } from "./../../constants/UrlConstants";
import Store from "../../content/Store";
import { connect } from "react-redux";
import Contentify from "../../content/Contentify";
import { setNotifications } from "../../actions/notifications/notificationsAction";
import { NotificationUpdateThreshold } from "../../constants/Constants";

export class NotificationsLink extends React.Component {
  componentDidUpdate = (previousProps) => {
    if (
      this.hasThereBeenAnInteractionWithTheSite(previousProps) &&
      this.hasNotificationThresholdBeenExceeded()
    ) {
      this.props.setNotifications(this.props.selectedPolicy);
    }
  };

  hasThereBeenAnInteractionWithTheSite = (previousProps) =>
    previousProps.lastInteractionTime !== this.props.lastInteractionTime;

  hasNotificationThresholdBeenExceeded = () =>
    Date.now() - this.props.lastRequestedTime > NotificationUpdateThreshold;

  render = () => {
    let iconClass = "icon-notification";
    if (this.props.notificationCount) {
      iconClass += " count-icon";
    }
    return (
      <Link to={Paths.Notifications}>
        <i className={iconClass} data-count={this.props.notificationCount} />
        <span className="hidden-sm-down">
          {this.props.content.notificationsLink}
        </span>
      </Link>
    );
  };
}

NotificationsLink.content = Store.Notifications;

export const mapStateToNotificationsLink = ({
  notificationsReducer,
  policyReducer,
  networkStateReducer
}) => ({
  selectedPolicy: policyReducer.selectedPolicy,
  notificationCount:
    notificationsReducer.selectedPolicy &&
    notificationsReducer.selectedPolicy.notifications &&
    notificationsReducer.selectedPolicy.notifications.length,
  lastRequestedTime:
    notificationsReducer.selectedPolicy &&
    notificationsReducer.selectedPolicy.lastRequestedTime,
  lastInteractionTime:
    networkStateReducer && networkStateReducer.lastInteractionTime
});

export default connect(mapStateToNotificationsLink, { setNotifications })(
  Contentify(NotificationsLink)
);
